export default __webpack_public_path__ + "static/steam_b.55bf1bf3ae9ad04557462cc2f5fcec6c.svg";